import _ from "lodash";

export const translateDays = (translate, days, useShortNotations) => {
  const suffix = useShortNotations ? "_short" : "";

  return _.map(days, (day) => translate(`${day}${suffix}`));
};
